import { render, staticRenderFns } from "./AddDiscipleModal.vue?vue&type=template&id=1e26b879&"
import script from "./AddDiscipleModal.vue?vue&type=script&lang=js&"
export * from "./AddDiscipleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDiscipleModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports